import React from "react";
import PropTypes from "prop-types";
import { Navbar, NavbarBrand } from "shards-react";
import { GoChevronLeft } from "react-icons/go";
import { Store, Dispatcher, Constants } from "../../../flux";

class SidebarMainNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuVisible: Store.getMenuState(),
    };
    this.onChange = this.onChange.bind(this);
    this.handleToggleSidebar = this.handleToggleSidebar.bind(this);
  }

  componentWillMount() {
    Store.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    Store.removeChangeListener(this.onChange);
  }

  async onChange() {
    this.setState({
      ...this.state,
      menuVisible: Store.getMenuState(),
    });
  }

  handleToggleSidebar() {
    Dispatcher.dispatch({
      actionType: Constants.TOGGLE_SIDEBAR,
    });
  }

  render() {
    const toggle_class = this.state.menuVisible ? "sidebar-open" : "sidebar-close";
    const { hideLogoText } = this.props;

    const SUB_DOMAIN = process.env.REACT_APP_SUB_DOMAIN;
    const dashboard = `${SUB_DOMAIN}/view-projects-superadmin`;



    return (
      <div className="main-navbar">
        <Navbar className="align-items-stretch bg-white flex-md-nowrap border-bottom p-0" type="light">
          <NavbarBrand className="w-100 mr-0" href={dashboard} style={{ lineHeight: "25px" }}>
            <div className="d-table m-auto">
              <img
                id="main-logo"
                className="d-inline-block align-top mr-1"
                style={{ maxWidth: "140px" }}
                src={require("../../../images/logo.png")}
                alt="IQVIA Unstructured Data"
              />
              <br />
              {!hideLogoText && <div className="d-none d-md-inline ml-1">Unstructured Data</div>}
            </div>
          </NavbarBrand>
          <a className={`toggle-sidebar ${toggle_class}`} onClick={this.handleToggleSidebar}>
            <GoChevronLeft />
          </a>
        </Navbar>
      </div>
    );
  }
}

SidebarMainNavbar.propTypes = {
  /**
   * Whether to hide the logo text, or not.
   */
  hideLogoText: PropTypes.bool,
};

SidebarMainNavbar.defaultProps = {
  hideLogoText: false,
};

export default SidebarMainNavbar;
